export const EngagementOptions = [
  {
    id: 'single-project',
    title: 'Single project',
    description: 'One defined piece of work, like a new website, a case study series, or a trade show campaign.',
    bestFor: 'a launch, a show, or a website that needs to get done.',
    includes: ['Scope and price approved up front', 'A delivery date in writing', 'Two rounds of revisions'],
  },
  {
    id: 'monthly-marketing',
    title: 'Monthly marketing',
    description: 'An ongoing plan across the channels that bring you work, run by one team.',
    bestFor: 'companies that want a steady flow of opportunities.',
    includes: ['A monthly plan and a monthly report', 'Content, campaigns, and outreach', 'One point of contact'],
  },
  {
    id: 'marketing-audit',
    title: 'Marketing audit',
    description: 'A review of your website, listings, and campaigns, with a prioritized list of fixes.',
    bestFor: 'companies deciding where to invest next.',
    includes: ['Website and search review', 'Comparison with your competitors', 'A prioritized action plan'],
  },
];